$(document).ready(function () {
    // The default in-stock filter is applied by the early inline script in the
    // 'collection-instock-mask' snippet; the delegated #load-more handler below
    // survives its grid swap and picks up the filtered next-page URL.
    $(document).on("click", "#load-more", function () {
      let $btn = $(this);
      let nextPageUrl = $btn.attr("data-next-page");
  
      if (!nextPageUrl) return;
  
      $.get(nextPageUrl, function (data) {
        let $newProducts = $(data).find("#product-grid").html();
        let $newButton = $(data).find("#load-more");
  
        $("#product-grid").append($newProducts);
  
        if ($newButton.length) {
          $btn.attr("data-next-page", $newButton.attr("data-next-page"));
        } else {
          $btn.remove();
        }
  
        // // Update URL
        // let url = new URL(window.location.href);
        // let currentPage = url.searchParams.get("page") || 1;
        // url.searchParams.set("page", Number(currentPage) + 1);
        // window.history.pushState({}, "", url);
      }).fail(function () {
        console.error("Error loading more products.");
      });
    });


    $(".cg-sorting-wrap .sorting-title").on("click", function(){
        console.log('clickeD?!');
        $(".cg-sorting-wrap").toggleClass("opened");
        $(".cg-sorting-wrap .sorting-options").toggleClass("active");
        $(".collection-prod-grid .facets-container").removeClass("active");
    });

    $(".filtering-title .filtering-btn").on("click", function(){
        $(".cg-sorting-wrap").removeClass("opened");
        $(".cg-sorting-wrap .sorting-options").removeClass("active");
        $(".collection-prod-grid .facets-container").toggleClass("active");
    });

    $(document).click(function(event) {
        if (
                !$(event.target).closest('.custom-sorting-wrap').length && 
                !$(event.target).is('.custom-sorting-wrap') && 
                !$(event.target).closest('.filtering-title').length && 
                !$(event.target).is('.filtering-title') && 
                !$(event.target).closest('.facets-container').length && 
                !$(event.target).is('.facets-container')
            ) 
        {
            $(".cg-sorting-wrap").removeClass("opened");
            $(".cg-sorting-wrap .sorting-options").removeClass("active");
            $(".collection-prod-grid .facets-container").removeClass("active");
        }
    });


    $(".cg-sorting-wrap .sorting-options .custom-option").on("click", function(){
        var option_val = $(this).attr("data-value");
        var option_text = $(this).text().trim();
        $(".cg-sorting-wrap").removeClass("opened");
        $(".cg-sorting-wrap .sorting-options").removeClass("active");

        $(".cg-sorting-wrap .sorting-title .txt").text(option_text);

        var nativeSelect = document.getElementById("SortBy");
        var inputEvent = new Event('input', { bubbles: true });
        var changeEvent = new Event('change', { bubbles: true });

        if (nativeSelect) {
            nativeSelect.value = option_val;
            nativeSelect.dispatchEvent(inputEvent);
            nativeSelect.dispatchEvent(changeEvent);
        }
    });




  });
  